module.exports = __webpack_public_path__ + "assets/img/logo-rakumart.c236c0db.svg";